/**
 * Infotip component renders an SVG icon that represents a infotip.
 *
 * @return {JSX.Element} SVG component for a infotip icon.
 */
function InfotipIcon() {
    return (
        <svg
            width="24px"
            height="24px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -24 100 125"
            version="1.1"
            x="0px"
            y="0px"
        >
            <g stroke="none" strokeWidth="1" fillRule="evenodd">
                <path d="M28.089,52.744 L47.281,52.744 C48.987,52.744 50.37,54.127 50.37,55.833 C50.37,57.539 48.987,58.922 47.281,58.922 L28.089,58.922 C26.383,58.922 25,57.539 25,55.833 C25,54.127 26.383,52.744 28.089,52.744 L28.089,52.744 Z M25,41.502 L25,41.502 C25,39.796 26.383,38.413 28.089,38.413 L71.911,38.413 C73.617,38.413 75,39.796 75,41.502 C75,43.208 73.617,44.591 71.911,44.591 L28.089,44.591 C26.383,44.591 25,43.208 25,41.502 L25,41.502 Z M25,27.171 L25,27.171 C25,25.465 26.383,24.082 28.089,24.082 L71.911,24.082 C73.617,24.082 75,25.465 75,27.171 C75,28.877 73.617,30.26 71.911,30.26 L28.089,30.26 C26.383,30.26 25,28.877 25,27.171 L25,27.171 Z M88.822,64 C88.822,66.107 87.107,67.822 85,67.822 L67.729,67.822 L50,82.891 L32.271,67.822 L15,67.822 C12.893,67.822 11.178,66.107 11.178,64 L11.178,19 C11.178,16.892 12.893,15.178 15,15.178 L85,15.178 C87.107,15.178 88.822,16.892 88.822,19 L88.822,64 Z M85,9 L15,9 C9.477,9 5,13.477 5,19 L5,64 C5,69.523 9.477,74 15,74 L30,74 L50,91 L70,74 L85,74 C90.523,74 95,69.523 95,64 L95,19 C95,13.477 90.523,9 85,9 L85,9 Z" />
            </g>
        </svg>
    );
}

export default InfotipIcon;
